import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/rerunGoal';
import { fetchRequest as refreshDetail } from '../../actions/discovery/goalDetail';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  const goalId = action?.payload?.goalId;
  try {
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/run`,
      {},
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
    yield put(refreshDetail({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
